module.exports = __webpack_public_path__ + "static/img/user4.659a8c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v1/user4.png
// module id = nlgb
// module chunks = 0